<template>
  <div class="video">
    <p class="bread">
      <router-link
        style="text-decoration: none; color: var(--font-color)"
        to="/"
      >
        فروشگاه اینترنتی شمع خورشید
      </router-link>

      <router-link
        style="text-decoration: none; color: var(--font-color)"
        to="/video/list"
      >
        / لیست ویدیوها
      </router-link>
      <router-link
        style="text-decoration: none; color: var(--font-color)"
        :to="{
          name: 'video_detail',
          params: { id: $route.params.id, num: 1 },
        }"
      >
        / ویدویو شماره {{ hhh }}
      </router-link>
    </p>
    <div class="con">
      <div class="video__container">
        <div class="video__container__main">
          <Media
            class="sss789"
            :poster="p_src"
            :kind="'video'"
            :controls="true"
            :src="v_src"
          >
          </Media>
          <div class="video__container__main--text">
            <p>{{ text_t }}:</p>
            <p v-html="text_d"></p>
          </div>
        </div>
        <div class="video__container__sub">
          <router-link
            :key="(item, index)"
            v-for="(item, index) in v_list"
            class="video__container__sub--item"
            :to="{
              name: 'video_detail',
              params: { id: $route.params.id, num: item.order },
            }"
            :class="[item.order == $route.params.num ? 'jkljkl' : '']"
          >
            <div class="con2456465">
              <img
                class="video__container__sub--item-img"
                :src="item.image"
                alt=""
              />
              <div class="con3">
                <font-awesome-icon
                  v-if="item.order == $route.params.num"
                  class="video__container__sub--item-svg"
                  icon="pause"
                />
                <font-awesome-icon
                  v-else
                  class="video__container__sub--item-svg"
                  icon="play"
                />
              </div>
            </div>

            <p class="video__container__sub--item-text">
              {{ item.title }}
            </p>
          </router-link>
        </div>
      </div>
      <!-- <div class="video__container__main--text">
        <P
          >لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
          استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در
          ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و
          کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی
          در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می
          طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی
          الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت
          می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت
          تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و
          جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار
          گیرد.</P
        >
      </div> -->
    </div>
  </div>
</template>

<script>
// import "../src/custom-theme.css";
// Similarly, you can also introduce the plugin resource pack you want to use within the component
// import "some-videojs-plugin";
import VueCoreVideoPlayer from "vue-core-video-player";
import Media from "@dongido/vue-viaudio";
export default {
  components: {
    Media,
  },
  data() {
    return {
      hhh: "1",
      v_src: "",
      p_src: "",
      v_list: [],
      text_t: "",
      text_d: "",
      playerOptions: {
        // videojs options
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: null,
          },
        ],
        poster: "",
      },
    };
  },
  watch: {
    $route(to, from) {
      var that = this;
      that.hhh = this.$route.params.num;
      // console.log(that.hhh, "nnnnnnnnnnnnnnnnnnnnnnnn");
      that.$store.state.load = true;
      var id = this.$route.params.id;
      var idd = this.$route.params.num;
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/teaching/playlist/" +
          id +
          "/playlist/?index=" +
          idd,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.$store.state.load = false;
          that.v_list = data;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          scroll(0, 0);
        },
      });
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/teaching/playlist/" +
          id +
          "/video/?index=" +
          idd,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.$store.state.load = false;
          that.p_src = data.image;
          that.v_src = data.link;
          that.text_t = data.title;
          that.text_d = data.description;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          scroll(0, 0);
        },
      });
    },
  },
  created() {
    var that = this;
    that.hhh = this.$route.params.num;
    // console.log(that.hhh);
    that.$store.state.load = true;
    var id = this.$route.params.id;
    var idd = this.$route.params.num;
    $.ajax({
      url:
        that.$store.state.url +
        "api/v1/teaching/playlist/" +
        id +
        "/playlist/?index=" +
        idd,
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.$store.state.load = false;
        that.v_list = data;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        scroll(0, 0);
      },
    });
    $.ajax({
      url:
        that.$store.state.url +
        "api/v1/teaching/playlist/" +
        id +
        "/video/?index=" +
        idd,
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.$store.state.load = false;
        that.p_src = data.image;
        that.v_src = data.link;
        that.text_t = data.title;
        that.text_d = data.description;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        scroll(0, 0);
      },
    });
  },
  mounted() {
    // console.log("this is current player instance object", this.player);
  },
  computed: {
    player() {
      // return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied(player) {
      // console.log("the player is readied", player);
      // you can use it to do something...
      // player.[methods]
    },
  },
};
</script>
<style lang="scss">
.con {
  position: relative;
  direction: rtl;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.164);
  // width: 100%;
  // height: 500px;
  // display: flex;
  // justify-content: flex-start;
  // align-items: center;
  width: 95%;
  height: 100%;
  background: var(--main-color);
  padding: 2em;
  @media screen and (max-width: 900px) {
    padding: 2em;
  }
}
.video-js {
  width: 100%;
  height: 450px;
  @media screen and (max-width: 1100px) {
    height: 350px;
  }
  @media screen and (max-width: 900px) {
    height: 350px;
  }
  @media screen and (max-width: 900px) {
    height: 300px;
  }

  // margin-right: 0.5em;
  // margin-right: 3em;
}
.video-player-box {
  // box-shadow: 0 0 1px rgba(0, 0, 0, 0.247);
}
.video {
  margin-top: 10em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__container {
    // position: relative;
    direction: rtl;
    border-radius: 8px;
    // box-shadow: 0 0 5px rgba(0, 0, 0, 0.164);
    // width: 100%;
    // height: 500px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    background: var(--main-color);
    // padding: 2em;

    &__sub {
      // background: red;
      display: flex;
      flex-direction: column;
      // background: red;
      width: 45%;
      // height: 100%;
      max-height: 600px;
      overflow-x: hidden;
      scrollbar-width: thin;
      scrollbar-color: var(--bg-color) var(--main-color);
      border-radius: 5px;
      // margin-left: -2em;
      margin-right: 1em;
      // margin-top: -1em;
      @media screen and (max-width: 900px) {
        width: 100%;
      }
      &--item {
        transition: all 0.5s;
        &:hover {
          // background: rgba(222, 228, 255, 0.527);
          // color: honeydew;
        }
        &:hover .con3 {
          // width: 20%;
          // background: none;
        }
        color: var(--font-color);
        border: 1px solid rgb(235, 235, 255);
        border-radius: 5px;
        margin-bottom: 0.5em;
        background: var(--bg-color);
        display: flex;
        padding: 1em;
        margin-left: 0.5em;
        text-decoration: none;
        justify-content: center;
        align-items: center;
        // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.13);
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.103);
        &-svg {
          color: var(--sub-color);
          font-size: 1em;
          position: absolute;
          // background: var(--main-color);
          // width: 200px;
          // height: 100%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          // padding: 0.15em;
          // width: 100px;
          // height: 0px;
          border-radius: 50%;
          // margin: 2em;
        }
        &-img {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        &-text {
          font-size: 0.7em;
          text-align: justify;
          width: 100%;
          // margin-right: 5em;
        }
      }
    }
    &__main {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      // align-items: center;
      // background: blue;
      width: 45%;
      margin-left: 2em;
      // height: 700px;
      @media screen and (max-width: 900px) {
        width: 100%;
        // justify-content: center;
        // align-items: center;
        margin: 0em;
      }

      &--text {
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        margin-top: 3em;
        border-top: 1px solid rgba(128, 128, 128, 0.452);
        padding: 1em;
        font-size: 0.9em;
        text-align: justify;
        p {
          margin-bottom: 0.5em;
        }
        @media screen and (max-width: 1100px) {
          font-size: 0.8em;
        }
        @media screen and (max-width: 900px) {
          font-size: 0.7em;
          margin-bottom: 2em;
          border-bottom: 1px solid rgba(128, 128, 128, 0.452);
        }
      }
    }
  }
}
.con2456465 {
  // background: red;
  position: relative;
  margin-left: 1em;
  width: 180px;
  height: 110px;
}
.video-player-box {
  // margin-left: 1em;1
}
.con3 {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(240, 255, 240, 0.61);
  transition: all 0.5s;
}
.jkljkl {
  background: var(--shrink);
  pointer-events: none;
}
.sss789 {
  background: black;
  height: 400px;
}
.bread {
  // direction: rtl;
  margin-left: auto;
  margin-right: 3em;
  margin-top: -0.5em;
  margin-bottom: 1em;
  // margin-right: 0.6em;
  // margin: 1em;
  align-self: flex-start;
  font-size: 0.8em;
  @media screen and (max-width: 800px) {
    font-size: 0.6em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/video/video_detail.vue